import initialState from '../../store/initialState';
import {
    GET_TOWER_LOCATIONS_ERROR,
    GET_TOWER_LOCATIONS_STARTING,
    GET_TOWER_LOCATIONS_SUCCESS,
} from '../../constants/actionTypes';
import clone from "lodash/cloneDeep";

export default function towerLocationsReducer(state = initialState.towerLocations, action) {
    switch (action.type) {
        case GET_TOWER_LOCATIONS_STARTING: {
            const { placeId } = action;

            const newState = clone(state);

            if (!newState[placeId]) {
                newState[placeId] = clone(initialState.towerLocations.placeId);
            }

            const updateData = newState[placeId];
            updateData.loading = true;
            updateData.loaded = false;
            updateData.error = null;

            return newState;
        }

        case GET_TOWER_LOCATIONS_SUCCESS: {
            const { placeId, data } = action;

            const newState = clone(state);

            if (!newState[placeId]) {
                newState[placeId] = clone(initialState.towerLocations.placeId);
            }

            const updateData = newState[placeId];
            updateData.loading = false;
            updateData.loaded = true;
            updateData.towerLocationsMap = data.towerLocationsMap;
            updateData.error = null;

            return newState;
        }

        case GET_TOWER_LOCATIONS_ERROR: {
            const { placeId } = action;
            const newState = clone(state);

            if (!newState[placeId]) {
                newState[placeId] = clone(initialState.towerLocations.placeId);
            }

            const updateData = newState[placeId];
            updateData.loading = false;
            updateData.loaded = false;
            newState.error = action.err ? action.err : 'Failed to retrieve tower locations.';

            return newState;
        }

        default: {
            return state;
        }
    }
}
